/**
 * * @module component/video.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import VimeoPlayer from "@vimeo/player";
import owlCarousel from "owl.carousel";

const Video = Backbone.View.extend({
  initialize: function () {
    var _this = this
  },

  loadVideo: function () {
    // Load and start video on modal show
    var _this = this;

    $("#video-modal").on("show.bs.modal", function (e) {
      var $modal = $("#video-modal");
      var button = $(e.relatedTarget);
      var caption = button.find("figcaption").text();
      var provider = button.data("video-provider");

      if ($('.video-embed', button).length) {
        $("#video", $modal).html($('.video-embed iframe', button).clone());

        return;
      }

      $(e.currentTarget).find("button").data("video-provider", provider);

      if (caption != "") {
        $(".caption", $(this)).addClass("with-text").text(caption);
      }

      if (window.YT && provider == "youtube") {
        //_this.player.loadVideoById(button.data('video'))

        _this.initPlayer(button.data("video"));
      } else if (provider == "vimeo") {
        _this.loadVimeoPlayer(button.data("video"));
      } else {
        // let iframe = $('iframe', button);
        let iframe = button.next('.audio-file');
        console.log(button, iframe);
        if(iframe){
          $("#video", $modal).html(iframe);
          $modal.addClass('audio');
        }
      }
    });

    // Stop video on modal close
    $("#video-modal").on("hide.bs.modal", function (e) {
      var $modal = $("#video-modal");
      var provider = $(e.currentTarget).find("button").data("video-provider");

      // if (YT && provider == 'youtube') {
      //     _this.player.stopVideo()
      // }

      $("#video").replaceWith('<div id="video"></div>');
      if($modal.hasClass('audio')){
        $modal.removeClass("audio");
      }
    });
  },

  // Youtube API
  onYouTubeIframeAPIReady: function () {
    // console.log('API READY')
    var _this = this;

    $(function () {
      if (window.YT) {
        _this.YT = window.YT;
        //_this.initPlayer(YT)
      } else {
        window.onYouTubeIframeAPIReady = function () {
          // console.log('YT')
          _this.YT = window.YT;
          //_this.initPlayer(YT)
        };
      }
    });
  },

  loadVimeoPlayer: function (video) {
    var _this = this;
    var options = {
      id: video,
      width: 640,
      loop: false,
      autoplay: true,
      byline: false,
      portrait: false,
      title: false,
      playsinline: true,
    };

    _this.player = new VimeoPlayer("video", options);
    _this.player.play();
    _this.sendUserPlayingEvent(video);
  },

  initPlayer: function (video) {
    var _this = this;

    this.youtube_video = video
    //if (!$('#video').is('iframe')) return

    // Init video player
    _this.player = new window.YT.Player("video", {
      videoId: video,
      height: "100%",
      width: "100%",

      playerVars: {
        autoplay: 1,
        controls: 1,
        showinfo: 0,
        rel: 0,
      },
      events: {
        onReady: function(e){
          e.target.playVideo();

          _this.sendUserPlayingEvent(_this.youtube_video);
        },
        //onStateChange: _this.onPlayerStateChange
      },
    });
  },

  onPlayerReady: function (e, view) {
    console.log("PLAYER READY");

    e.target.playVideo();

    view.sendUserPlayingEvent(view.youtube_video);
  },

  sendUserPlayingEvent(videoId) {

      var _this = this;

      let headers = new Headers();
      headers.append('Accept', 'application/json');

      // GET USER FROM COOKIE: spektrix_customers
      var spektrix_customer = localStorage.getItem('spektrixCustomer')

      console.log(spektrix_customer)
      if (spektrix_customer) {

          var spektrix_data = JSON.parse(spektrix_customer)

          const user_id = spektrix_data.data.id || null

          const event_id = document.body.classList.toString().match(/postid-(\d+)/)[1]

          const post_data = {
            'action': 'started_watching_video',
            'user': user_id,
            'nonce': ajax_client.ajax_nonce,
            'event_id': event_id
          }

          $.post(ajax_client.ajax_url, post_data, (response, textStatus) => console.log('Response: ', response, textStatus))
      }
  },

});

export default Video;